module.exports = __webpack_public_path__ + "static/media/siblings-1.d64a9cdd.svg";